export default "__VITE_ASSET__wDWeJ01x__"